<template>
  <div class="not-found-container">
    <div class="card shadow-none">
      <div class="card-body text-center">
        <div class="mb-4 text-primary" style="font-size: 100px;">
          <i class="ph-duotone ph-warning-circle"></i>
        </div>
        <h1 class="mb-4">{{ $t('common.error.notFoundTitle') }}</h1>
        <p class="mb-4">{{ $t('common.error.notFoundMessage') }}</p>
        <router-link to="/profile" class="btn btn-primary">
          <i class="ph-duotone ph-house me-2"></i>
          {{ $t('common.navigation.profile') }}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>

<style scoped>
.not-found-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 20px;
}

.card {
  max-width: 500px;
  width: 100%;
}
</style> 